import { Box, LinearProgress } from '@mui/material'
import { useGlobalLoading } from 'api/hooks/use-global-loading'

export const ProgressBar = () => {
  const isLoading = useGlobalLoading()

  return (
    <Box sx={{ height: '5px' }}>
      {isLoading && (
        <LinearProgress
          sx={(theme) => ({
            height: '5px',
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.primary.light,
            '& .MuiLinearProgress-bar': {
              backgroundColor: theme.palette.primary.main,
            },
          })}
        />
      )}
    </Box>
  )
}
